module.exports = "<p>\r\n  repayment works!\r\n</p>\r\n"